import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTable, useFlexLayout, Column } from 'react-table';
import { Button } from 'react-bootstrap';
import CommonModal from '../common/CommonModal';
import { IinitialState } from '../../reducers';
import { toggleModalVirtualSapWoParts } from '../../actions/manageInventoryActions';
import { WithTranslation, withTranslation } from 'react-i18next';

type RowType = {
    number: string;
    description: string;
    woNumber: string;
};

const VirtualSapWOPartsModal = ({ t }: WithTranslation) => {
    const dispatch = useDispatch();

    const { show, rows } = useSelector((state: IinitialState) => {
        const showModal = state.manageInventory.showModalVirtualSapWoParts;
        const virtualWorkOrderParts = state.parts.virtualWorkOrderParts || [];

        // Map the virtualWorkOrderParts from the API to table rows
        // Format Number column as "Qty + Part #"
        const tableRows: RowType[] = virtualWorkOrderParts.map((part: any) => ({
            number: `(${part.estimated || 0})  ${part.number || ''}`,
            description: part.description || '',
            woNumber: part.workOrderNumber || ''
        }));

        return { show: showModal, rows: tableRows };
    });

    const onHide = () => dispatch(toggleModalVirtualSapWoParts());

    const columns = useMemo<Column<RowType>[]>(
        () => [
            { Header: t('manageInventory:virtualSapWoPartsNumber'), accessor: 'number', width: 150 },
            { Header: t('common:description'), accessor: 'description' },
            { Header: t('manageInventory:virtualSapWoPartsWoNumber'), accessor: 'woNumber', width: 180 }
        ],
        [t]
    );

    const { getTableProps, getTableBodyProps, headerGroups, rows: tableRows, prepareRow } = useTable(
        { columns, data: rows },
        useFlexLayout
    );

    return (
        <CommonModal className="" title={t('manageInventory:virtualSapWoParts')} show={show} onHide={onHide}>
            <div>
                <div
                    {...getTableProps()}
                    className={`ReactTable beacon-table -highlight blue flex-layout`}
                    style={{ width: '100%', height: '400px', overflow: 'auto' }}
                >
                    <div className="rt-thead -header">
                        {headerGroups.map(headerGroup => (
                            <div {...headerGroup.getHeaderGroupProps()} key={headerGroup.getHeaderGroupProps().key} className="rt-tr">
                                {headerGroup.headers.map(column => (
                                    <div {...column.getHeaderProps({ className: 'rt-th' })} key={column.getHeaderProps().key}>
                                        {column.render('Header')}
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                    <div {...getTableBodyProps()} className="rt-tbody">
                        {tableRows.map((row, rowIndex) => {
                            prepareRow(row);
                            return (
                                <div
                                    {...row.getRowProps()}
                                    key={row.getRowProps().key}
                                    className={`rt-tr ${rowIndex % 2 === 0 ? '-odd' : '-even'}`}
                                >
                                    {row.cells.map(cell => (
                                        <div {...cell.getCellProps()} key={cell.getCellProps().key} className="rt-td">
                                            {cell.render('Cell')}
                                        </div>
                                    ))}
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="form-buttons text-right">
                    <Button variant="default" type="button" className="cancel-button" onClick={onHide}>
                        {t('common:close')}
                    </Button>
                </div>
            </div>
        </CommonModal>
    );
};

export default withTranslation()(VirtualSapWOPartsModal);


